import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import APP_ROUTES from '../../../constants/app-routes';
import styles from './styles/header-styles.scss';

import logo from '../../../images/katapulk_logo.svg';

class BrandHeader extends Component {
    render() {
        return (
            <Link to={APP_ROUTES.homePageRoute} className={`navbar-brand ${styles.navBarHeader}`}>
                <img src={logo} alt="Logo" />
            </Link>
        );
    }
}

export default BrandHeader;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/brand-header.jsx
 **/